import TabNodeLayoutData from "../NodeLayouts/TabNodeLayoutData";
import DelayComponent from "../SidePanel/Inspector/components/DelayComponent";
import InspectorFooter from "../SidePanel/Inspector/components/InspectorFooter";
import InspectorNodeHeader from "../SidePanel/Inspector/components/InspectorNodeHeader";
import NodePanel from "./NodePanel";
import { NodeInterface } from "@swivl-mono/types";
import InspectorCarouselCard from "../SidePanel/Inspector/components/InspectorCarouselCard";
import { RandomId } from "@swivl-mono/helpers";

const Carousel = {
  Type: "carousel",
  Empty: function () {
    const cardId1 = RandomId(6);
    const cardId2 = RandomId(6);
    const buttonId1 = RandomId(6);
    const buttonId2 = RandomId(6);

    let data = {
      "id": RandomId(6),
      "type": Carousel.Type,
      "delay": 0,
      "showTyping": false,
      "cards": [{
        "id": cardId1,
        "mediaUrl": "https://s3.amazonaws.com/client-demo-resources/On+boarding+Mason/Hoover+Full.png",
        "title": "",
        "description": "",
        "size": "large",
        "actions": [
          {
            "text": "Button Text",
            "id": buttonId1,
            "cardId": cardId1,
            "onSelectGoto": null,
            "payload": buttonId1,
            "displayText": "Button Text"
          }
        ],
      },
      {
        "id": cardId2,
        "mediaUrl": "https://s3.amazonaws.com/client-demo-resources/On+boarding+Mason/Hoover+Full.png",
        "title": "",
        "description": "",
        "size": "large",
        "actions": [
          {
            "text": "Button Text",
            "id": buttonId2,
            "cardId": cardId2,
            "onSelectGoto": null,
            "payload": buttonId2,
            "displayText": "Button Text"
          }
        ],
      },
      ]
    };
    return data;
  },

  PlumbData: function (node: NodeInterface) {
    let tabs = [] as any[];

    if (node.cards) {
      for (var i = 0; i < node.cards.length; i++) {
        let card = node.cards[i];
        for (var j = 0; j < card.actions.length; j++) {
          let action = card.actions[j];
          tabs.push({
            "id": "cards_" + card.id + ".actions_" + action.id,
            "source": "cards_" + i + "_actions_" + j + "_onSelectGoto",
            "target": action.onSelectGoto,
            "title": "Item " + (i + 1) + ": " + action.text,
            imageURL: (j === 0) ? card.mediaUrl : undefined
          })
        }
      }
    }

    return TabNodeLayoutData({
      node: node,
      title: "Carousel",
      baseWidth: 170,
      tabs: tabs
    });
  },

  InspectorPanel: class CarouselInspectorPanel extends NodePanel {
    constructor(props: any) {
      super(props);
      this.addCard = this.addCard.bind(this)
    }

    addCard() {
      const newCardId = RandomId(6);
      const newButtonId = RandomId(6);
      let cardData = {
        "id": newCardId,
        "mediaUrl": "https://s3.amazonaws.com/client-demo-resources/On+boarding+Mason/Hoover+Full.png",
        "title": "",
        "description": "",
        "size": "large",
        "actions": [{
          "text": "Button Text",
          "id": newButtonId,
          "cardId": newCardId,
          "onSelectGoto": null,
          "payload": newButtonId
        }],
      };
      this.addItemToArray(cardData, "cards", true)
    }

    render() {
      var self = this;
      let cardViews;
      if (this.props.node.cards) {
        cardViews = this.props.node.cards.map(function (item: any, index: any) {

          return (<div className="buttonElement" key={index}>
            <InspectorCarouselCard
              key={item.id}
              card={item}
              cards={self.props.node.cards}

              arrayIndex={index}
              onChange={self.onChange}
              onChangeUpdate={self.onChangeUpdateAndRedraw}
              deleteValue={self.deleteValue}
              // moveItemInArray={self.moveItemInArray}
              addItemToArray={self.addItemToArray}
            />
          </div>)
        })
      }

      return (<div>
        <div className="panel carousel_panel">
          <InspectorNodeHeader title="Carousel" />
          <DelayComponent node={this.props.node} onChange={this.onChange} />
          <div className="cardList">
            {cardViews}
            <div className="addElementButton" onClick={this.addCard}>+ ADD CARD</div>
            <div className="carouselPadding">.</div>
          </div>
        </div>
        <InspectorFooter deleteNode={this.deleteNode} node={this.props.node} />
      </div>);
    }
  }
}
export default Carousel;
